import React, { useContext, useMemo } from 'react';
import { JsonPointerPath } from 'types/dynamic-forms/JsonPointerPath';

const PropertyPathStackContext = React.createContext<JsonPointerPath>([]);

export const PropertyPathStackProvider: React.FC<React.PropsWithChildren<{ pushPath: JsonPointerPath }>> = ({
  pushPath,
  children,
}) => {
  const pushedByParent = useContext(PropertyPathStackContext);
  const path = [...pushedByParent, ...pushPath];
  const memoizedPath = useMemo(() => path, path);
  return <PropertyPathStackContext.Provider value={memoizedPath}>{children}</PropertyPathStackContext.Provider>;
};

export function useCurrentPath() {
  const pathStack = useContext(PropertyPathStackContext);
  return pathStack;
}

export default function usePropertyPath(propertyId: string) {
  const pathStack = useContext(PropertyPathStackContext);
  // Must be memoized because path is supposed to be used in deps array for hooks
  const propertyPath = useMemo(() => [...pathStack, propertyId], [pathStack, propertyId]);
  return propertyPath;
}
